export const PLACEMENTS_STATUS = {
  ROOT: '/placementsStatus',
};
